import * as z from 'zod';
import { GeoJson } from '@ais-ui/api-spec/shapes';
import { Filter } from '@ais-ui/websockets';
import { GroundingConfigurationSchema } from '@ais-ui/api-spec/grounding';
import { mutualDetectorFormSchema } from '../Mutations/detectorForm';

export const fieldToGroundingAccordionMap: {
  [key in keyof GroundingDetectorFormValues]: string;
} = {
  name: 'detector-item',
  enabled: 'detector-item',
  selectedGroups: 'detector-item',
  severity: 'detector-item',
  filterId: 'detector-item',
  maintainShiplist: 'detector-item',
  acknowledgeRequired: 'detector-item',
  emails: 'detector-item',
  phones: 'detector-item',
  useShallowWaters: 'grounding-item',
  useSogDecrease: 'grounding-item',
  filterPorts: 'grounding-item',
  filterAnchorageAreas: 'grounding-item',
  useRemainsGroundedCheck: 'grounding-item',
  validateMinutes: 'grounding-item',
};

export const groundingDetectorFormSchema = mutualDetectorFormSchema
  .extend({
    useShallowWaters: z.boolean().optional(),
    useSogDecrease: z.boolean().optional(),
    filterPorts: z.boolean().optional(),
    filterAnchorageAreas: z.boolean().optional(),
    useRemainsGroundedCheck: z.boolean().optional(),
    validateMinutes: z.number().optional(),
  })
  .refine((data) => Boolean(data.shapeId) || Boolean(data.shape), {
    message: 'Shape must be provided',
    path: ['shapeId', 'shape'],
  });

export type GroundingDetectorFormValues = z.infer<
  typeof groundingDetectorFormSchema
>;

export const convertGroundingConfigurationFormValuesToBackend = (
  data: GroundingDetectorFormValues,
  shape: GeoJson,
  filter: Filter | undefined
): GroundingConfigurationSchema => {
  return {
    id: null,
    uuid: null,
    createdAt: null,
    createdBy: null,
    modifiedAt: null,
    modifiedBy: null,
    name: data.name,
    enabled: data.enabled,
    parameters: {
      useInSameLocation: data.useRemainsGroundedCheck, // This is deliberate because useInSameLocation and useRemainsGrounded is the same thing
      useStopCheck: true,
      useShallowWaters: data.useShallowWaters,
      useSogDecrease: data.useSogDecrease,
      useNavStat: false,
      filterPorts: data.filterPorts,
      filterAnchorageAreas: data.filterAnchorageAreas,
      useRemainsGroundedCheck: data.useRemainsGroundedCheck,
      validateMinutes: data.validateMinutes,
    },
    emailAddresses: data.emails,
    phoneNumbers: data.phones,
    shape: data.shapeId,
    severity: data.severity,
    acl: data.selectedGroups.map((group) => group.value),
    aclPut: [],
  };
};
